export const hasContent = (value: any[]): boolean => {
  return value?.length > 0;
};
